import { render, staticRenderFns } from "./CreatePdfLabelSheet.vue?vue&type=template&id=468b748f&scoped=true"
import script from "./CreatePdfLabelSheet.vue?vue&type=script&lang=ts"
export * from "./CreatePdfLabelSheet.vue?vue&type=script&lang=ts"
import style0 from "./CreatePdfLabelSheet.vue?vue&type=style&index=0&id=468b748f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468b748f",
  null
  
)

export default component.exports